import React from "react";
import { twMerge } from "tailwind-merge";

export const ExternalLink = ({
  link,
  className,
  children,
}: {
  link?: string;
  className?: string;
  children?: any;
}) => {
  return (
    <a
      href={link}
      target="__blank"
      className={twMerge(
        "inline-block font-semibold text-zinc-600 hover:text-green-500 transition duration-200",
        className
      )}
    >
      {children}
    </a>
  );
};
